// extracted by mini-css-extract-plugin
module.exports = {"bg":"progress_bg__ILptn","loading":"progress_loading__3n3Cn","el":"progress_el__2T-7t","percentage":"progress_percentage__1zI_2"};